import styled from 'styled-components'
import React from 'react'
import { tokens } from 'styling/tokens'
import { Hamburger as Icon } from 'assets/icons/sidebarHamburger'
import { useDispatch } from 'react-redux'
import { toggleSideBar } from 'features/global/globalSlice'
import { AppDispatch } from 'store'

export const SharedLayoutWrapper = styled.main`
  width: 100vw;
  position: relative;
  transition: .2s ease-in;
  min-height: 100vh;
  background:
    radial-gradient(1000px 420px at 62% -16%, rgba(255, 153, 0, 0.2), transparent 62%),
    radial-gradient(700px 360px at 8% 4%, rgba(255, 153, 0, 0.08), transparent 60%),
    radial-gradient(1400px 620px at 50% 108%, rgba(255, 153, 0, 0.16), transparent 60%),
    ${tokens.surface.base};

  ::before, ::after{
    width: 500px;
    height: 350px;
    border-radius: 100%;
    background-color: ${(prop) => prop.theme.colorOrange}29;
    position: fixed;
    content: '';
    z-index: 0;
    filter: blur(78px);
  }

  ::before{
    bottom: -50px;
    left: -50px;
  }

  ::after{
    top: -50px;
    right: -50px;
  }
`
interface DashboardContainerProps {
  sidebar?: boolean
}
export const DashboardContainer = styled.div<DashboardContainerProps>`
  position: fixed;
  top: 5rem;
  left: ${(props) => (props.sidebar ? '14rem' : '4rem')};
  bottom: 0;
  right: 0;
  transition: all 0.5s ease-in-out;
  z-index: 1;

  @media (max-width: 1024px) {
    left: 0;
  }
`

interface HamburgerStyledProps {
  sidebar?: boolean
}

const HamburgerStyled = styled.div<HamburgerStyledProps>`
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1rem;
  left: 1rem;
  width: 2rem;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 0px 1.8rem rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  width: 4rem;
`

export const HamburgerComponent = ({ sidebar }: { sidebar: boolean }) => {
  const dispatch = useDispatch<AppDispatch>()

  return (
    <HamburgerStyled sidebar={sidebar} onClick={() => dispatch(toggleSideBar())}>
      {Icon}
    </HamburgerStyled>
  )
}

